import React from "react";
// import Preloader from "./loader/preloader";
import HeaderRevamp from "./loader/header-revamp";

const Header = () => {
    return (
    <>
        {/* <Preloader /> */}
        <HeaderRevamp />
    </>
    )
}
export default Header;